import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

import { XrefApiKeyMasked } from 'src/app/services/xref-api/xref-api.service';

export type XrefApiKeyModalState = 'initial' | 'manage' | 'revealed';

@Component({
  selector: 'app-xref-api-key-manage-modal',
  templateUrl: './xref-api-key-manage-modal.component.pug',
  styleUrls: ['./xref-api-key-manage-modal.component.scss'],
  standalone: false,
})
export class XrefApiKeyManageModalComponent implements OnInit {
  apiKey: XrefApiKeyMasked | null = null;
  plaintextKey: string | null = null;
  state: XrefApiKeyModalState = 'initial';
  copied = false;
  docsUrl = 'https://docs.xref.com/';

  @Output() generateClick = new EventEmitter<void>();
  @Output() revokeClick = new EventEmitter<void>();

  constructor(public bsModalRef: BsModalRef) {}

  get copyButtonLabel(): string {
    return this.copied ? $localize`Copied` : $localize`Copy`;
  }

  get generateButtonLabel(): string {
    return this.state === 'initial' ? $localize`Generate key` : $localize`Generate new key`;
  }

  ngOnInit(): void {
    if (this.plaintextKey) {
      this.state = 'revealed';
    } else if (this.apiKey) {
      this.state = 'manage';
    } else {
      this.state = 'initial';
    }
  }

  generateKey(): void {
    this.copied = false;
    this.generateClick.emit();
  }

  revokeKey(): void {
    this.revokeClick.emit();
  }

  async copyKey(): Promise<void> {
    if (!this.plaintextKey) {
      return;
    }
    const clip = navigator.clipboard;
    if (!clip || typeof clip.writeText !== 'function') {
      return;
    }
    await clip.writeText(this.plaintextKey);
    this.copied = true;
  }

  close(): void {
    this.bsModalRef.hide();
  }

  openDocs(): void {
    window.open(this.docsUrl, '_blank', 'noopener');
  }
}
